import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
import config from './config.json';

const Step29 = ({ setStep, nextStep, setStep10optionLocal }) => {

  const currentStep = 29;
  const [project, setProject] = useState('');
 
  useEffect(() => {
    // Récupère la valeur du localStorage lors du chargement initial du composant
    const storedValue = localStorage.getItem('project');
    if (storedValue) {
      setProject(storedValue);
    }
  }, []);

  const handleChange = (e) => {
    const { value } = e.target;
    setProject(value);
    localStorage.setItem('project', value);
    setStep10optionLocal({
      travaux: (value === 'je_reflechis_a_mes_travaux'),
      adresse: (value === 'je_recherche_un_artisan_RGE' || value === 'je_vais_signer_mon_devis' || value === 'deja_signe_mon_devis'),
    });
    nextStep();
  };

  const tableauValeurs = JSON.parse(localStorage.getItem('work_types'));

  const prevSteps = () => {
   
    if(tableauValeurs.includes('poêle à bois')) {
     setStep(28);
    }
    else if(tableauValeurs.includes('chaudière bois')) {
     setStep(27);
    }
    else if(tableauValeurs.includes('radiateur électrique')) {
     setStep(25);
    }
    else if(tableauValeurs.includes('Chaudière gaz à condensation')) {
     setStep(24);
    }
    else if(tableauValeurs.includes('pompe à chaleur hybride')) {
     setStep(22);
    }
    else if(tableauValeurs.includes('Climatisation réversible')) {
     setStep(20);
    }
    else if(tableauValeurs.includes('pompe à chaleur géothermique')) {
     setStep(19);
    }
    else if(tableauValeurs.includes('pompe à chaleur air/eau')) {
     setStep(18);
    }
    else if(tableauValeurs.includes("isolation d'une toiture-terrasse")) {
     setStep(15);
    } 
    else if(tableauValeurs.includes('fenêtres')) {
     setStep(14);
    }
    else if(tableauValeurs.includes('isolation du sol')) {
     setStep(13);
    }
    else if(tableauValeurs.includes('isolation des murs')) {
     setStep(11);
    } 
    else if(tableauValeurs.includes('isolation des combles')) {
     setStep(9);
    } 
    else {
     setStep(6);
    }
  }
    
  const handleSubmit = (e) => {
    e.preventDefault();
    setStep10optionLocal({
      travaux: (project === 'je_reflechis_a_mes_travaux'),
      adresse: (project === 'je_recherche_un_artisan_RGE' || project === 'je_vais_signer_mon_devis' || project === 'deja_signe_mon_devis'),
    });
    nextStep();
  };

    return (
      <Container>
        <ProgressBar
          now={(currentStep / 36) * 100}
          style={{ backgroundColor: "#bad7f1" }}
        >
        <ProgressBar
          now={(currentStep / 36) * 100}
          style={{ backgroundColor: "#0be288" }}
        />
        </ProgressBar>
        <Form onSubmit={handleSubmit}>
         <Row className="mb-3">
            <Col>
                <h2>{config.step29.step}</h2>
                <h3>{config.step29.title}</h3>
            </Col>
          </Row>
          <Row className="mb-3 container-bloc">
          {[
            { label: 'Je réfléchis à mes travaux', value: 'je_reflechis_a_mes_travaux', image: `${config.linkImage}${config.step29.image1}` },
            { label: 'Je recherche un artisan RGE', value: 'je_recherche_un_artisan_RGE', image: `${config.linkImage}${config.step29.image2}`},
            { label: 'Je vais signer mon devis', value: 'je_vais_signer_mon_devis', image: `${config.linkImage}${config.step29.image3}`},
            { label: 'J\'ai déjà signé mon devis', value: 'deja_signe_mon_devis', image: `${config.linkImage}${config.step29.image4}`},
          ].map(({ label, value, image }, index) => (
            <Col key={index} className={`card ${project === value ? 'selected' : ''}`}>
            <label>
              <Form.Check
                type="radio"
                value={value}
                checked={project === value}
                onChange={handleChange}
                className='d-none'
              />
              <div className={`icon-container ${project === value ? 'selected' : ''}`}>
                <img src={image}  alt={label} className="size-img"/>
                <p>{label}</p>
              </div>
            </label>
            </Col>
          ))}
          </Row>
          <Row className="mt-3">
            <Col className="d-flex justify-content-between">
            <Button type="button" variant="secondary" onClick={prevSteps}>
            Précédent
            </Button>
            <Button type="submit" variant="primary" disabled={!project ? true : false} className="ms-3">
            Suivant 
            </Button>
          </Col>
          </Row>  
        </Form>
    </Container>

    );

}

export default Step29;